import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { AreaMarkOptions, MarkInterpolation, MarkTransform, MarkType } from '@mode-vegas/vegas';
import { IconComponent, trackByFactory } from '@mode/capra';
import { TransformItem } from './layer-options-menu-helpers';

@Component({
  standalone: true,
  imports: [CommonModule, IconComponent, MatDividerModule, MatLegacyMenuModule],
  selector: 'mode-area-options-menu',
  templateUrl: './area-options-menu.component.html',
  styleUrls: ['./area-options-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AreaOptionsMenuComponent implements OnChanges {
  @Input() markLayerOptions: AreaMarkOptions | undefined;

  @Output() layerOptionsChanged = new EventEmitter<AreaMarkOptions>();

  trackByValue = trackByFactory<TransformItem>(({ transform }) => transform);

  transformItems: TransformItem[] = [
    { label: 'Overlapped', transform: MarkTransform.Group },
    { label: 'Stacked', transform: MarkTransform.Stack },
    { label: '100% stacked', transform: MarkTransform.Stack100Percent },
  ];
  transform: MarkTransform | undefined;

  interpolationItems = [
    { label: 'Linear', type: MarkInterpolation.Linear },
    { label: 'Spline', type: MarkInterpolation.Spline },
    { label: 'Step', type: MarkInterpolation.Step },
    { label: 'Step before', type: MarkInterpolation.StepBefore },
    { label: 'Step after', type: MarkInterpolation.StepAfter },
  ];

  interpolationType: MarkInterpolation = MarkInterpolation.Linear;

  ngOnChanges(): void {
    this.transform = this.markLayerOptions?.transform ?? MarkTransform.Stack;
    this.interpolationType = this.markLayerOptions?.interpolation ?? MarkInterpolation.Linear;
  }

  setTransform(transform: MarkTransform): void {
    if (this.transform !== transform) {
      this.layerOptionsChanged.emit({ type: MarkType.Area, transform });
    }
  }

  setInterpolation(type: MarkInterpolation) {
    if (this.interpolationType !== type) {
      this.layerOptionsChanged.emit({ type: MarkType.Area, interpolation: type });
    }
  }
}
